// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-muted{color:#9b9b9b}.vx-form__input{border:none}.vx-form__input:disabled{background:#4a4a4a}\n", ""]);
// Exports
module.exports = exports;
